import { Injectable } from '@angular/core';
import { ToastService } from '@horizon/core-notifications';

interface StorageAction {
  action: 'delete' | 'get' | 'set';
}
@Injectable({
  providedIn: 'root',
})
export class StorageApiService {
  constructor(private readonly toastService: ToastService) {}

  public deleteLocalStorageData(key: string) {
    try {
      localStorage.removeItem(key);
    } catch (e: any) {
      this.handleStorageDataError({ action: 'delete' }, e);
    }
  }

  public getLocalStorageData(key: string): any {
    let value = localStorage.getItem(key);
    try {
      value = JSON.parse(value);
    } catch (e: any) {
      this.handleStorageDataError({ action: 'get' }, e);
      value = null;
    }
    return value;
  }

  public setLocalStorageData(key: string, value: string | object): void {
    try {
      if (typeof value === 'object') value = JSON.stringify(value);
      localStorage.setItem(key, value);
    } catch (e: any) {
      this.handleStorageDataError({ action: 'set' }, e);
    }
  }

  public deleteSessionStorageData(key: string) {
    try {
      sessionStorage.removeItem(key);
    } catch (e: any) {
      this.handleStorageDataError({ action: 'delete' }, e);
    }
  }

  public getSessionStorageData(key: string): any {
    let value = sessionStorage.getItem(key);
    try {
      value = JSON.parse(value);
    } catch (e: any) {
      this.handleStorageDataError({ action: 'get' }, e);
      value = null;
    }
    return value;
  }

  public setSessionStorageData(key: string, value: string | object): void {
    try {
      if (typeof value === 'object') value = JSON.stringify(value);
      sessionStorage.setItem(key, value);
    } catch (e: any) {
      this.handleStorageDataError({ action: 'set' }, e);
    }
  }

  private handleStorageDataError(action: StorageAction, error: any): void {
    this.toastService.showToastNotification({
      text: `storage.error.${action.action}`,
      type: 'error',
    });
  }
}
